<template>
    <div class="container">
        <div class="commerce-list-table">
            <ul>
                <li></li>
                <li>{{ filterCMSparams.words_translation.project }}</li>
                <li>{{ filterCMSparams.words_translation.part }}</li>
                <!-- <li>{{ filterCMSparams.words_translation.class }}</li> -->
                <li>{{ filterCMSparams.words_translation.level }}</li>
                <li>{{ filterCMSparams.words_translation.size }}</li>
                <li>{{ filterCMSparams.words_translation.price }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'commerce-list-table',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            filterCMSparams: 'loadFilterCMSparams',
        }),
        methods: {
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/commerce-page/commerce-list-table.scss';
</style>